import firebase from "firebase/app";
export default () => firebase.analytics();
